import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, effect, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UserService } from '../user.service';
import { CommonModule } from '@angular/common';
import { RouterOutlet, RouterLink, RouterLinkActive, Router } from '@angular/router';
import { UserInfo } from '../user-info/user-info';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { WorkRequestService } from '../work-request';
import { makeBlankTenantView, RequestListItem, TenantView } from '../models';

@Component({
  selector: 'app-my-work-orders',
  imports: [RouterOutlet, RouterLink, RouterLinkActive, FormsModule, CommonModule, UserInfo],
  templateUrl: './my-work-orders.html',
  styleUrl: './my-work-orders.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MyWorkOrdersComponent {
	@Input() displayContext: 'widget' | 'page' | null = 'page';

	safeMapUrl: SafeResourceUrl | null = null;
	currentTenant = computed(() => this.userService.currentTennant());
	loadedRequests = computed(() => this._wr.requestList());
	public showRequests: boolean[] = [];
	public reqLen: number | null = null;
	protected language: number = 2;
	protected currentLocale: string = 'en-US';

	constructor(public _wr: WorkRequestService, public userService: UserService, public router: Router, protected _cd: ChangeDetectorRef, private sanitizer: DomSanitizer) {
		effect(() => {
			const mapUrl = "www.google.com/maps?q=" + this.userService.currentTennant()?.Region + ", " + this.userService.currentTennant()?.City + ", " + this.userService.currentTennant()?.Address + "&output=embed";
			if (mapUrl) {
				this.safeMapUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://' + mapUrl);
			}
			const tenant = this.userService.currentTennant();
			this.language = tenant.Language;
			this.currentLocale = this.language == 2 ? 'ja' : 'en-US';
		
			if (this.currentTenant && this.loadedRequests.length == 0 ) {
				this._wr.getMyWorkRequests(this.currentTenant().Tenant_id)
			}
			
			this._cd.detectChanges();
		});
	}

	contentStrings : Record<string, Record<number, string>> = {
		MyWorkOrders: { 1: "My Work Orders", 2: "マイ作業指示" },
		NewWorkOrder: { 1: "New Work Order", 2: "新しい作業指示" },
		NoOutstandingWorkOrders: { 1: "No outstanding work orders", 2: "未処理の作業指示はありません" },
		Request: { 1: "Request #", 2: "リクエスト #" },
		Status: { 1: "Status:", 2: "ステータス：" },
		ShowDetails: { 1: "Show Details", 2: "詳細を表示" },
		HideDetails: { 1: "Hide Details", 2: "詳細を非表示" },
		Location: { 1: "Location:", 2: "場所：" },
		LastUpdated: { 1: "Last Updated:", 2: "最終更新：" },
		Description: { 1: "Description:", 2: "説明：" },
		ViewAllMyWorkOrders: { 1: "View All My Work Orders", 2: "すべての作業指示を表示" },
	}

}
